import { render, staticRenderFns } from "./ImageText.vue?vue&type=template&id=5b7b68ea&scoped=true"
import script from "./ImageText.vue?vue&type=script&lang=js"
export * from "./ImageText.vue?vue&type=script&lang=js"
import style0 from "./ImageText.vue?vue&type=style&index=0&id=5b7b68ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7b68ea",
  null
  
)

export default component.exports